const RAW_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/';
const NORMALIZED_BASE = RAW_BASE_URL.endsWith('/') ? RAW_BASE_URL : `${RAW_BASE_URL}/`;
const API_BASE_V1 = NORMALIZED_BASE.includes('/v1/') ? NORMALIZED_BASE : `${NORMALIZED_BASE}v1/`;

class WhatsAppConfigApi {
  getAuthToken() {
    return localStorage.getItem('authToken');
  }

  async getConfig() {
    const response = await fetch(`${API_BASE_V1}settings/whatsapp`, {
      headers: { Authorization: `Bearer ${this.getAuthToken()}` },
    });
    if (!response.ok) return null;
    const result = await response.json();
    return result.data;
  }

  async saveConfig(configData) {
    const existing = await this.getConfig();
    const method = existing ? 'PUT' : 'POST';
    const response = await fetch(`${API_BASE_V1}settings/whatsapp`, {
      method,
      headers: {
        Authorization: `Bearer ${this.getAuthToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(configData),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    return result.data;
  }

  async getPreferences(positionId) {
    const response = await fetch(`${API_BASE_V1}whatsapp-notifications/preferences/${positionId}`, {
      headers: { Authorization: `Bearer ${this.getAuthToken()}` },
    });
    if (!response.ok) return null;
    const result = await response.json();
    return result.data;
  }

  async savePreferences(positionId, preferences) {
    const response = await fetch(`${API_BASE_V1}whatsapp-notifications/preferences/${positionId}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getAuthToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(preferences),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    return result.data;
  }
}

export default new WhatsAppConfigApi();
